/*
 * Root Getters
 */
export default {
    getIsAuthenticated: (state) => state.isAuthenticated,
    getAuthStatus: (state) => state.status,
    getAppName(state) {
        return state.appName;
    },
    getAppUrl(state) {
        return state.appUrl;
    },
    getApiToken(state) {
        return state.apiToken;
    },
    getApiUrl(state) {
        return state.apiUrl;
    },
    getIsLoading(state) {
        return state.isLoading;
    },
    getModule(state) {
        return state.module;
    },
    getTitle(state) {
        return state.title;
    },
    getRoles(state) {
        return state.roles;
    },
};
